import { useBemCN } from '@gik/core/utils/bemBlock';
import type { AttachImageResult, RasterAttachImageResult } from '@gik/core/utils/FileUtils';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import type { PostMedia } from '@gik/stream/types/Stream';
import { Button } from '@gik/ui/Button';
import { Square, Wide } from '@gik/ui/KeepProportions';
import { KeepProportionRange } from '@gik/ui/KeepProportions/KeepProportionRange';
import { SvgIcon } from '@gik/ui/SvgIcon';
import XIcon from '@heroicons/react/solid/XIcon';
import React from 'react';

export interface IAttachmentsPreviewProps {
  attachments: AttachImageResult[] | PostMedia[];
  removeAttachment: (index: number) => void;
}

function AttachmentsPreviewComp({ attachments, removeAttachment }: IAttachmentsPreviewProps) {
  const bem = useBemCN('attachments-preview');

  return (
    <div {...bem()}>
      {attachments.map((attachment, i) => {
        const onClickRemove = () => void removeAttachment(i);
        return <AttachmentPreview key={i} attachment={attachment} onClickRemove={onClickRemove} />;
      })}
    </div>
  );
}

export const AttachmentsPreview = withComponentErrorBoundary(AttachmentsPreviewComp);

type IAttachmentPreviewProps = {
  attachment: AttachImageResult | PostMedia;
  onClickRemove: () => void;
};
function AttachmentPreview({ attachment, onClickRemove }: IAttachmentPreviewProps) {
  const bem = useBemCN('attachment-preview');

  return (
    <div {...bem()}>
      <KeepProportionRange
        {...bem('image')}
        proportionUpper={Square}
        proportionLower={Wide}
        src={(attachment as RasterAttachImageResult).base64 || (attachment as PostMedia).thumbnailUrl}
      />
      <div {...bem('remove-button-wrapper')}>
        <Button noFocusStyling circle size="sm" variant="black-outline" onClick={() => void onClickRemove()}>
          <SvgIcon Icon={XIcon} />
        </Button>
      </div>
    </div>
  );
}
